import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, isRef as _isRef, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d1645e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content" };
const _hoisted_2 = { class: "main_title" };
const _hoisted_3 = { class: "main_box" };
const _hoisted_4 = { class: "input_group" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "button_box" };
import { ref, computed } from 'vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import TextWithLabel from '@/materials/molecules/TextWithLabel.vue';
import { useMessage } from '@/const/messages';
import { useOneTimePasscode, ONE_TIME_PASSCODE_CHANNEL_EMAIL } from '@/logics/one_time_passcode';
export default /*#__PURE__*/ _defineComponent({
    emits: ["submitted", "close"],
    setup(__props, { emit }) {
        const { oneTimePasscodeId, postOnetimePassword, resetOnetimePassword, verifyOnetimePassword } = useOneTimePasscode();
        const { format, ONE_TIME_PASSCODE, ONE_TIME_PASSCODE_ERROR } = useMessage();
        const code = ref('');
        const codeErrorMessage = ref('');
        const isLoading = ref(false);
        const getCodeLabel = computed(() => {
            if (!!oneTimePasscodeId.value)
                return ONE_TIME_PASSCODE.REGET_CODE;
            return ONE_TIME_PASSCODE.GET_CODE;
        });
        const currentCode = computed({
            get: () => code.value,
            set: (value) => {
                code.value = value;
            },
        });
        const onClickGetCode = () => {
            if (isLoading.value)
                return;
            try {
                isLoading.value = true;
                !!oneTimePasscodeId.value ? resetOnetimePassword() : postOnetimePassword(ONE_TIME_PASSCODE_CHANNEL_EMAIL);
            }
            finally {
                isLoading.value = false;
            }
        };
        const onSubmit = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g;
            if (isLoading.value)
                return;
            if (!oneTimePasscodeId.value) {
                codeErrorMessage.value = format(ONE_TIME_PASSCODE_ERROR.NEED_GET_CODE);
                return;
            }
            if (!currentCode.value) {
                codeErrorMessage.value = format(ONE_TIME_PASSCODE_ERROR.REQUIRED_VERIFY_CODE);
                return;
            }
            try {
                isLoading.value = true;
                yield verifyOnetimePassword(currentCode.value);
                onClose();
                emit('submitted');
            }
            catch (err) {
                if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 400) {
                    codeErrorMessage.value = !!((_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d.passcode) ? (_g = (_f = (_e = err.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.errors) === null || _g === void 0 ? void 0 : _g.passcode[0] : null;
                }
            }
            finally {
                isLoading.value = false;
            }
        });
        const onClose = () => emit('close');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "overlay overlay_z",
                    onClick: onClose
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("label", null, _toDisplayString(_unref(format)(_unref(ONE_TIME_PASSCODE).VERIFY_TITLE)), 1),
                        _createVNode(MaterialIcon, {
                            name: "close",
                            class: "close_button",
                            onClick: onClose
                        })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(TextWithLabel, {
                                reference: _unref(currentCode),
                                "onUpdate:reference": _cache[0] || (_cache[0] = ($event) => (_isRef(currentCode) ? (currentCode).value = $event : null)),
                                label: _unref(format)(_unref(ONE_TIME_PASSCODE).INPUT_LABLE_VERIFY_CODE),
                                "has-error": !!codeErrorMessage.value,
                                "invalid-message": codeErrorMessage.value
                            }, null, 8, ["reference", "label", "has-error", "invalid-message"]),
                            _createElementVNode("a", {
                                href: "#",
                                class: "link",
                                onClick: _withModifiers(onClickGetCode, ["prevent"])
                            }, _toDisplayString(_unref(format)(_unref(getCodeLabel))), 9, _hoisted_5)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                            onClick: onSubmit,
                            class: "act-btn"
                        }, _toDisplayString(_unref(format)(_unref(ONE_TIME_PASSCODE).BTN_SUBMIT)), 1)
                    ])
                ])
            ], 64));
        };
    }
});
